import importScheduleDialogViewState from "../components/importSchedule/lib/store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction("showImportScheduleDialog", function showImportScheduleDialog(
    show: boolean
) {
    importScheduleDialogViewState().dialogOpen = show;
});